import { ListResponseModel } from ".";
import { AuditLog } from "../model/audit-log";

import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/logshandler"
const auditLogEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAuditLogs: builder.query<ListResponseModel<Array<AuditLog>>, any>({
            query: params => ({
                url: `${serviceBaseurl}/audit-log/utility`,
                params,
                method: "GET",
            }),
            providesTags: ["AuditLogs"],
        }),
    })
});

export const { useGetAuditLogsQuery  } = auditLogEndpoints;
